import { render, staticRenderFns } from "./agogis-lecturer-lookup.vue?vue&type=template&id=6e3ca151"
import script from "./agogis-lecturer-lookup.vue?vue&type=script&lang=ts"
export * from "./agogis-lecturer-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports